import type {
  TPartnerCommission,
  TPartnerCommissionServer,
  TShopServer,
  TShop,
} from '../../store/types';

const partnerCommissionAdapter = (item: TPartnerCommissionServer): TPartnerCommission => ({
  currency: item.currency,
  commissionPercent: Number(item.commission_percent),
  calculationBase: item.calculation_base ?? 'platform_commission',
});

export const shopsAdapter = (items: TShopServer[]): TShop[] => items.map((item) => ({
  id: item.id,
  created: item.created,
  name: item.name,
  token: item.token,
  ownerId: item.owner_id,
  callbackUrl: item.callback_url,
  homepageUrl: item.homepage_url,
  successUrl: item.success_url,
  failureUrl: item.failure_url,
  status: item.status,
  type: item.type,
  referralCode: item.referral_code,
  balances: item.balances,
  partnerCommissions: item.partner_commissions.map(partnerCommissionAdapter),
}));
